import Vuex from 'vuex';

import accountStore from '@/store/modules/accountStore';
import aiStore from '@/store/modules/aiStore';
import appLayoutStore from '@/store/modules/appLayoutStore';
import businessAlertStore from '@/store/modules/businessAlertStore';
import campaignTargetStore from '@/store/modules/campaigns/campaignTargetStore';
import campaignTargetListStore from '@/store/modules/campaigns/campaignTargetListStore';
import chatbotStore from '@/store/modules/chatbotStore';
import conferenceStore from '@/store/modules/conferenceStore';
import contactStore from '@/store/modules/contactStore';
import creditStore from '@/store/modules/creditStore';
import emailSignatureStore from '@/store/modules/emailSignatureStore';
import emailStore from '@/store/modules/emailStore';
import eventCaptureStore from '@/store/modules/eventCaptureStore';
import exportStore from '@/store/modules/exportStore';
import externalPushStore from '@/store/modules/externalPushStore';
import interactionStore from '@/store/modules/interactionStore';
import fileStorageStore from '@/store/modules/fileStorageStore';
import historyStore from '@/store/modules/historyStore';
import inquiryStore from '@/store/modules/inquiryStore';
import linkedinStore from '@/store/modules/linkedinStore';
import myListsStore from '@/store/modules/myListsStore';
import notificationStore from '@/store/modules/notificationStore';
import nylasStore from '@/store/modules/nylasStore';
import queryStore from '@/store/modules/queryStore';
import quickSearchStore from '@/store/modules/quickSearchStore';
import resultStore from '@/store/modules/sequence/resultStore';
import resultV2Store from '@/store/modules/sequence/resultV2Store';
import schoolStore from '@/store/modules/schoolStore';
import scoringStore from '@/store/modules/scoringStore';
import sequenceDetailStore from '@/store/modules/sequence/sequenceDetailStore';
import sequenceStore from '@/store/modules/sequence/sequenceStore';
import sequenceTargetListStore from '@/store/modules/sequence/sequenceTargetListStore';
import socialSellingStore from '@/store/modules/socialSellingStore';
import tagStore from '@/store/modules/tagStore';
import targetStore from '@/store/modules/sequence/targetStore';
import taskStore from '@/store/modules/sequence/taskStore';
import smartMailingStore from '@/store/modules/smartMailingStore';
import teamMonitoringStore from '@/store/modules/teamMonitoringStore';
import templatesAndSignaturesStore from '@/store/modules/templatesAndSignaturesStore';
import toastStore from '@/store/modules/toastStore';
import toastV2Store from '@/store/modules/toastV2Store';
import userStore, { valuePropositionSyncPlugin } from '@/store/modules/userStore';
import websocketStore from '@/store/modules/websocketStore';
import dashboardStore from '@/store/modules/dashboardStore';

export default new Vuex.Store({
  plugins: [valuePropositionSyncPlugin],
  modules: {
    account: accountStore,
    ai: aiStore,
    app_layout: appLayoutStore,
    dashboard: dashboardStore,
    business_alert: businessAlertStore,
    campaign_target: campaignTargetStore,
    campaign_target_list: campaignTargetListStore,
    chatbot: chatbotStore,
    conference: conferenceStore,
    contact: contactStore,
    credit: creditStore,
    email_signature: emailSignatureStore,
    email: emailStore,
    event_capture: eventCaptureStore,
    export: exportStore,
    external_push: externalPushStore,
    interaction: interactionStore,
    file_storage: fileStorageStore,
    history: historyStore,
    inquiry: inquiryStore,
    linkedin: linkedinStore,
    my_lists: myListsStore,
    notification: notificationStore,
    nylas: nylasStore,
    query: queryStore,
    quick_search: quickSearchStore,
    result: resultStore,
    result_v2: resultV2Store,
    school: schoolStore,
    scoring: scoringStore,
    sequence_detail: sequenceDetailStore,
    sequence: sequenceStore,
    sequence_target_list: sequenceTargetListStore,
    social_selling: socialSellingStore,
    tag: tagStore,
    target: targetStore,
    task: taskStore,
    smart_mailing: smartMailingStore,
    team_monitoring: teamMonitoringStore,
    templates_and_signatures: templatesAndSignaturesStore,
    toast: toastStore,
    toast_v2: toastV2Store,
    user: userStore,
    websocket: websocketStore,
  },
});
